import React from 'react';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { SiteFooter } from '../components/ui/SiteFooter';
import { SiteHeader } from '../components/ui/SiteHeader';
import { FoundingOffer } from '../components/practitioners/FoundingOffer';
import { foundingOffer } from '../data/foundingOffer';
export function PractitionersPage() {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-792" data-mp="2za5nc8cdjf86">
      {/* Navigation */}
      <SiteHeader currentPath="/practitioners" data-id="element-793" data-mp="3s0ea6dhuunt3" />

      <main className="pt-16 md:pt-24 pb-24" data-id="element-794" data-mp="3s1p9a00cv7dv">
        {/* Intro */}
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-795" data-mp="3n0rxc55xv9kt">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-5" data-id="element-796" data-mp="3i2q9z81hco3j">
            For Practitioners
          </p>
          <h1 className="font-serif text-4xl md:text-6xl text-charcoal leading-[1.05] mb-6 tracking-tight" data-id="element-797" data-mp="2bngzl60oosjn">
            Join the Network
          </h1>
          <p className="text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-798" data-mp="zlduta3gihxe">
            Become part of a curated community of trusted practitioners shaping
            the future of women's wellness.
          </p>
        </div>

        {/* Founding member offer */}
        <div className="max-w-3xl mx-auto px-6 mt-10" data-id="element-799" data-mp="ppanzqxntv44">
          <div className="rounded-3xl bg-purple-800 px-7 py-8 md:px-10 md:py-9 text-center" data-id="element-800" data-mp="ul82rst9ytes">
            <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-purple-200" data-id="element-801" data-mp="fwbwa06v9oga">
              <SparklesIcon aria-hidden="true" className="w-4 h-4" data-id="element-802" data-mp="kpeghhpr7ljt" />
              Founding member offer
            </p>
            <p className="mt-4 font-serif text-2xl md:text-3xl text-white leading-snug" data-id="element-803" data-mp="6uvjxmwhrc9f">
              {foundingOffer.headline}
            </p>
            <p className="mt-4 text-base text-purple-100/90 leading-relaxed max-w-xl mx-auto" data-id="element-804" data-mp="3t3n2g6xrte30">
              {foundingOffer.subline}
            </p>
            <p className="mt-5 text-sm text-purple-200/80" data-id="element-805" data-mp="1zpy0o339xlc">
              Offer closes {foundingOffer.deadline}.
            </p>
            <a href="/practitioners/join" className="mt-7 inline-flex items-center justify-center rounded-full bg-white px-8 py-3.5 text-base font-semibold text-purple-900 transition-colors duration-200 ease-out hover:bg-purple-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-200 focus-visible:ring-offset-2 focus-visible:ring-offset-purple-800" data-id="element-806" data-mp="3a7xz4xzry2fi">
              Join Fem Entity
            </a>
          </div>
        </div>

        {/* Offer detail */}
        <div className="max-w-3xl mx-auto px-6 mt-20 md:mt-24" data-id="element-807" data-mp="3ny1gbajsr5y3">
          <FoundingOffer data-id="element-808" data-mp="3izzx8pmdf6mm" />
        </div>

        {/* Application form */}
        <section id="apply" aria-labelledby="apply-heading" className="max-w-3xl mx-auto px-6 mt-20 md:mt-24 scroll-mt-28" data-id="element-809" data-mp="3j22m36bsetpr">
          <div className="rounded-3xl border border-purple-200 bg-white px-7 py-10 md:px-12 md:py-12 text-center shadow-[0_18px_50px_-30px_rgba(44,44,44,0.5)]" data-id="element-810" data-mp="27jrp88o6733k">
            <h2 id="apply-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-811" data-mp="s1v9fktbzytk">
              Ready to join?
            </h2>
            <p className="mt-4 max-w-xl mx-auto text-base text-charcoal/70 leading-relaxed" data-id="element-812" data-mp="11roj2g9wy3v6">
              Create your account and choose your membership here, then complete
              your practitioner profile and verification in the Fem Entity app.
            </p>
            <a href="/practitioners/join" className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-purple-700 px-8 py-4 text-base font-semibold text-white transition-colors duration-200 ease-out hover:bg-purple-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-813" data-mp="1aqjqfvop1k02">
              Join Fem Entity
              <ArrowRightIcon aria-hidden="true" className="w-4 h-4" data-id="element-814" data-mp="1gt3q0bf1pvmm" />
            </a>
          </div>
        </section>
      </main>

      <SiteFooter currentPath="/practitioners" data-id="element-815" data-mp="1btqu71675e7w" />
    </div>;
}